<template>
  <div class="attention_articles">
    <div class="attention_articles_title">
      <h2 class="title c5a ab">注目記事</h2>
    </div>
    <div class="attention_articles_list">
      <div class="attention_post" v-for="(val, index) in attention_article_lists">
        <Post
          :title="val.title"
          :thumbnail="val.thumbnailImagePath"
          :hashtag="val.tagList"
          :date="val.publicationDate"
          :is_new="false"
          :is_ranking="0"
          :id="val.articleId"
          :key="index"
          :is_attention="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Post from '@/components/fanClub/column/Post';

export default {
  props: ['attention_article_lists'],
  components: {
    Post,
  },
}
</script>

<style lang="css" scoped>
.attention_articles {
  margin: 30px 0 0 0;
}
.attention_articles_title {
  margin-bottom: 10px;
}
.attention_articles_list {
  border-bottom: 1px solid  #ccc;
  border-top: 1px solid  #ccc;
}
.attention_post {
  margin: 10px 0 20px 0;
}
.title {
  text-align: left;
  color: #1DB9B9;
}
</style>


// WEBPACK FOOTER //
// src/components/fanClub/column/AttentionArticles.vue